import React, { Fragment, useState } from 'react';
import Services from '../../api/service'
import { useParams, Navigate } from 'react-router-dom'
import ModalVideo from 'react-modal-video'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import Bg from '../../images/bg/page_bg01.jpg'
import icon from '../../images/icon/ser-01.svg'
import srImg from '../../images/shape/brd_shape.png'
import vImg2 from '../../images/video/polygon02.png'
import shape from '../../images/shape/sd-shape.png'
import sicon from '../../images/icon/check-icon.svg'


const ServiceSinglePage = (props) => {

    const { slug } = useParams()

    const ServiceDetails = Services.find(item => item.slug === slug)

    const [isOpen, setOpen] = useState(false)

    // Redirect if service not found or doesn't have detail page data
    if (!ServiceDetails || !ServiceDetails.detailPage) {
        return <Navigate to="/service" replace />
    }

    const detail = ServiceDetails.detailPage;

    return (
        <Fragment>
            <div className="sco_agency">
                <Header />
                <main className="page_content service-details-page">
                    <section className="page-title  pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                        <div className="container">
                            <div className="page-title-wrap sd-title-wrap">
                                <div className="row mt-none-30 align-items-end">
                                    <div className="col-lg-9 mt-30">
                                        <div className="page-title-box">
                                            <span className="sub-title"><img src={icon} alt="" /> {ServiceDetails.title} Services</span>
                                            <h2 className="title">
                                                {detail.pageTitle} <br /> {detail.pageTitleHighlight} <br /> {detail.pageSubtitle}
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mt-30">
                                        <div className="sd-right-img pos-rel">
                                            <img src={detail.rightImage} alt="" />
                                            <div className="sd-arrow-shape">
                                                <img className="xbzoominzoomup" src={srImg} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="video pt-70 pb-65">
                        <div className="container">
                            <div className="xb-video sd-video pos-rel">
                                <img src={detail.videoImage} alt="" />
                                <button className="popup-video btn-video" onClick={() => setOpen(true)}><img src={vImg2} alt="" /></button>
                            </div>
                        </div>
                    </div>
                    <div className="sd-ser-content_wrap pb-110">
                        <div className="container">
                            <div className="sd-ser-content">
                                <h2 className="sd-title">{detail.mainTitle}</h2>
                                {detail.content.map((paragraph, index) => (
                                    <Fragment key={index}>
                                        <p className="sd-content">{paragraph}</p>
                                        {index < detail.content.length - 1 && <br />}
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="sd-process_warp">
                        <div className="container">
                            <div className="sd-heading">
                                <h2 className="sd-title">{detail.processTitle}</h2>
                                <p className="sd-content">{detail.processDescription}</p>
                            </div>
                            <div className="sd-process_inner ul_li">
                                {detail.processSteps.map((step, index) => (
                                    <div className="sd-process-item" key={index}>
                                        <div className="xb-item--icon"><img src={step.icon} alt="" /></div>
                                        <h3 className="xb-item--title">{step.title}</h3>
                                        <p className="xb-item--contact">{step.description}</p>
                                        <span className="xb-item--number">{step.number}</span>
                                    </div>
                                ))}
                                <div className="sd-shape"><img src={shape} alt="" /></div>
                            </div>
                        </div>
                    </div>
                    <div className="sd-service_wrap pt-115 pb-130">
                        <div className="container">
                            <div className="sd-ser-outcome">
                                <div className="sd-heading">
                                    <h2 className="sd-title">{detail.outcomeTitle}</h2>
                                    <p className="sd-content">{detail.outcomeDescription}</p>
                                </div>
                                <div className="sd-list-item ul_li">
                                    <ul className="sd-ser-list list-unstyled">
                                        {detail.outcomes.slice(0, Math.ceil(detail.outcomes.length / 2)).map((outcome, index) => (
                                            <li key={index}><img src={sicon} alt="" />{outcome}</li>
                                        ))}
                                    </ul>
                                    <ul className="sd-ser-list list-unstyled">
                                        {detail.outcomes.slice(Math.ceil(detail.outcomes.length / 2)).map((outcome, index) => (
                                            <li key={index}><img src={sicon} alt="" />{outcome}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <CtaSection />
            </div>
            <Footer />
            <Scrollbar />
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId={detail.videoId} onClose={() => setOpen(false)} />
        </Fragment>
    )
};
export default ServiceSinglePage;